import * as CONST from 'framework/modules/searchadmin/constants';

export const getDefaultSettingPageDataAction = () => ({
  type: CONST.ACTION_DEFAULT_SETTINGS_GET_PAGE_DATA
});

export const saveDefaultSettingsAction = () => ({
  type: CONST.ACTION_DEFAULT_SETTINGS_SAVE_DATA
});
